import skygear from 'skygear';

const Activity = skygear.Record.extend('activity');

export function getActivitiesByCategory(category) {
  const query = new skygear.Query(Activity);
  query.equalTo('category', category);
  query.addDescending('position');
  query.addDescending('_created_at');
  query.notEqualTo('hidden', true);
  query.limit = null;
  return skygear.publicDB.query(query);
}

export function getFeaturedActivities() {
  const query = new skygear.Query(Activity);
  query.equalTo('featured', true);
  query.notEqualTo('hidden', true);
  query.addDescending('featurePosition');
  query.addDescending('_created_at');
  query.limit = null;
  return skygear.publicDB.query(query);
}

export function getActivityById(id) {
  const query = new skygear.Query(Activity);
  query.equalTo('_id', id);
  query.limit = 1;
  return skygear.publicDB.query(query).then(records => records[0]);
}



// WEBPACK FOOTER //
// ./src/models/Activity.js